import { Model } from 'pinia-orm';
import { Attr, Str, Uid, Num } from 'pinia-orm/decorators';
import type { AvatarConfig } from '../types/avatarConfig';
import type { ApiAvatarAvatar } from 'src/types/contentTypes';
import type { StrapiAttr } from 'src/types/strapi';

/** Scalar field types are derived from the backend schema — see src/types/strapi.ts. */
type AvatarAttr<K extends keyof ApiAvatarAvatar['attributes']> = StrapiAttr<
  ApiAvatarAvatar,
  K
>;

export class Avatar extends Model {
  static override entity = 'avatars';

  @Uid() declare id: number;
  @Str('') declare documentId: string;
  @Str('') declare style: AvatarAttr<'style'>;
  @Str('') declare seed: AvatarAttr<'seed'>;
  // Stored as JSON on the backend, which Strapi cannot describe structurally.
  @Attr(null) declare avatar_config: AvatarConfig | null;
  @Str(null) declare avatar_svg: AvatarAttr<'avatar_svg'> | null;
  @Num(null) declare user_id: number | null; // Foreign key (one-to-one with User)
  @Str('') declare createdAt: string;
  @Str('') declare updatedAt: string;
}
